import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import StepLabel from '@mui/material/StepLabel';
import MDButton from "dashboard/components/MDButton";
import Typography from '@mui/material/Typography';
import { Card, Alert, Icon } from '@mui/material';
import MDBox from 'dashboard/components/MDBox';


export default function HorizontalNonLinearStepper(props) {
  const {steps, children, StepValidation, reset } = props;
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [permission, setPermission] = React.useState(false);
  

  const totalSteps = () => steps.length;

  const completedSteps = () => Object.keys(completed).length;

  const isLastStep = () => activeStep === totalSteps() - 1;

  const allStepsCompleted = () => completedSteps() === totalSteps();

  const handleNext = async () => {
    const checkPermission = await StepValidation(activeStep);
    setPermission(checkPermission);
    if(!checkPermission) return;
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    const newActiveStep =
      isLastStep() && !allStepsCompleted() 
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(prevStep => prevStep > step && StepValidation(activeStep) ? step : prevStep);
    // setDisabled(disabled.map( (item, i) => i === step ?? false ))
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };
  
  React.useEffect(() =>  reset && handleReset() , [reset])

  return (
    <Card>
    <Box sx={{ width: '100%' }}>
      <Stepper sx={{mx:2, mt:-3}} nonLinear activeStep={activeStep} alternativeLabel> 
        {steps.map((label, index) => (
          <Step key={label} completed={completed[index]}>
            <StepButton color="inherit" onClick={handleStep(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        {allStepsCompleted() ? (
          <>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Box sx={{ flex: '1 1 auto' }} />
              <MDButton variant="gradient" color="dark" onClick={handleReset}>Reset</MDButton>
            </Box>
          </>
        ) : (
          <>
            {children && React.Children.map(children, child => activeStep === child.props.stepIndex  && <Stepchild disabled={activeStep !== child.props.stepIndex} >{child}</Stepchild> )}
            <Box sx={{ display: 'flex', flexDirection: 'row', p:2 }}>
              <MDButton
                variant="gradient" color="light"
                disabled={activeStep === 0}
                onClick={handleBack}
                sx={{ mr: 1 }}
              >
                Back
              </MDButton>
              <Box sx={{ flex: '1 1 auto' }} />
              <MDButton disabled={activeStep === steps.length -1} variant="gradient" color="primary" onClick={handleNext} sx={{ mr: 1 }}>
                Next
              </MDButton>
              {activeStep === steps.length -1  && <MDButton size="medium" disabled={!permission}  sx={{ mr: 1 }}  variant="gradient" color="info" type="submit" >
                <Icon fontSize="medium" sx={{mr:1}}>save</Icon>
                    Save
              </MDButton>}
              {activeStep !== steps.length &&
                (completed[activeStep] ? (
                  <Alert sx={{py:0, px:1}} iconMapping={{ success: <CheckCircleOutlineIcon fontSize="inherit" />}}>     
                    <small>Step {activeStep + 1} already completed</small>
                  </Alert>

                ) : null)}
            </Box>
          </>
        )}
      </div>
    </Box>
    </Card>
  );
}
function Stepchild ({children, disabled}) {
  return (
    <MDBox p={2}>
      {React.cloneElement(children, {disabled})}
    </MDBox>
  )
}